// extracted by mini-css-extract-plugin
module.exports = {"itemDragLayer":"ItemDragLayer_itemDragLayer__1_KjB"};